import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Config } from 'datatables.net-dt';
import { forkJoin } from 'rxjs';
import { AuthService } from 'src/app/auth/_service/auth.service';
import { ApiService } from 'src/app/shared/_service/api.service';

@Component({
	selector: 'app-ordini-agenti',
	templateUrl: './ordini-agenti.component.html',
	styleUrls: ['./ordini-agenti.component.scss'],
})
export class OrdiniAgentiComponent implements OnInit {
	constructor(
		private api: ApiService,
		private modalService: NgbModal,
		private authService: AuthService,
	) {}

	dtSettings: Config = {
		columnDefs: [
			{ searchable: true, targets: 0, orderable: true },
			{ searchable: false, targets: [1, 2, 3, 4, 5, 6], orderable: false, width: '50px' },
			{ searchable: false, targets: [7, 8, 9, 10, 11], orderable: false },
		],
	};

	ordini = [];
	ordiniVisualizzati = [];

	anni = [];

	filtri = {
		anno: new Date().getFullYear(),
		daConfermare: true,
		parola: '',
	};

	modalRef: NgbModalRef;
	selectedOrder;
	jsonInAddTocart = {
		quantita: 0,
		codiceCommerciale: undefined,
	};
	addProductErrorMessage = false;

	isAgenteInterno = this.authService.isAgenteInterno;

	ngOnInit() {
		for (let i = new Date().getFullYear(); i >= 2021; i--) {
			this.anni.push(i);
		}
		this.updateOrders();
	}

	filtra() {
		this.filtri.parola = this.filtri.parola.trim();
		this.ordiniVisualizzati = this.ordini.filter((o) => {
			return (
				o.utente.cliente.clientePlm.idBertazzoni.includes(this.filtri.parola) ||
				o.utente.cliente.codiceCliente.includes(this.filtri.parola) ||
				o.prodottiCarrello.find((pc) => pc.prodottoCommerciale.codiceCommerciale.includes(this.filtri.parola))
			);
		});
	}

	conferma(ordine) {
		this.api.confermaOrdineAgente({ idOrdine: ordine.id }).subscribe((res2) => {
			ordine.confermato = true;
			this.updateOrders();
		});
	}

	totaleOrdineAListino(ordine) {
		let totale = 0;
		ordine.prodottiCarrello.forEach((item) => {
			if (item.prodottoCommerciale.listini[0]) {
				totale += item.quantita * item.prodottoCommerciale.listini[0].prezzoNetto;
			}
		});
		return totale;
	}

	totaleOrdine(ordine) {
		let totale = 0;
		ordine.prodottiCarrello.forEach((item) => {
			if (item.prodottoCommerciale.listini[0]) {
				totale += item.quantita * (item.prezzoScontatoApprovato || item.prezzoUnitarioOriginale);
			}
		});
		return totale;
	}

	totaleOrdineScontoApprovato(ordine) {
		let totale = 0;
		ordine.prodottiCarrello.forEach((item) => {
			if (item.prodottoCommerciale.listini[0]) {
				totale += item.quantita * item.prezzoScontatoApprovato;
			}
		});
		return totale;
	}

	totaleOrdineScontoRichiesto(ordine) {
		let totale = 0;
		ordine.prodottiCarrello.forEach((item) => {
			if (item.prodottoCommerciale.listini[0]) {
				totale += item.quantita * item.scontoAssolutoRichiesto;
			}
		});
		return totale;
	}

	trovaNSimag(ordine) {
		const item = ordine.prodottiCarrello.find(({ nOrdineSimag }) => nOrdineSimag && nOrdineSimag !== '0' && nOrdineSimag.trim() !== '');
		return item ? item.nOrdineSimag : 'N/D';
	}

	editOrder(products, order) {
		this.selectedOrder = order;
		this.jsonInAddTocart.codiceCommerciale = undefined;
		this.jsonInAddTocart.quantita = 0;
		this.addProductErrorMessage = undefined;
		this.modalRef = this.modalService.open(products, { ariaLabelledBy: 'modal-basic-title', size: 'lg', windowClass: 'mw-95' });
	}

	saveProduct(product) {
		product.feEdit = false;
		this.editOrDeleteProduct(product, false);
	}

	closeModal() {
		this.modalRef.close();
		this.updateOrders();
	}

	updateOrders() {
		this.api.getOrdiniFiltrati(this.filtri.anno, undefined).subscribe((res) => {
			this.ordini = res.sort((a, b) => b.dataRegistrazioneOrdine - a.dataRegistrazioneOrdine).filter((o) => o.prodottiCarrello.length > 0);

			// Filtro i listini
			this.ordini.forEach((o) => {
				o.prodottiCarrello.forEach((item) => {
					item.prodottoCommerciale.listini = item.prodottoCommerciale.listini.filter((l) => l.cliente === o.utente.cliente.codiceCliente);

					// Assegno gli sconti da listino ai prodotti carrello
					item.sconto_1_1_approvato = item.sconto_1_1_approvato ?? this.getSconto('1_1', item);
					item.sconto_2_1_approvato = item.sconto_2_1_approvato ?? this.getSconto('2_1', item);
					item.sconto_3_1_approvato = item.sconto_3_1_approvato ?? this.getSconto('3_1', item);
					item.sconto_1_2_approvato = item.sconto_1_2_approvato ?? this.getSconto('1_2', item);
					item.sconto_2_2_approvato = item.sconto_2_2_approvato ?? this.getSconto('2_2', item);
					item.sconto_3_2_approvato = item.sconto_3_2_approvato ?? this.getSconto('3_2', item);
				});
			});

			this.ordiniVisualizzati = this.ordini;
			this.filtra();

			this.ordiniVisualizzati.map((order) => {
				order.feOpen = order.id === (this.selectedOrder && this.selectedOrder.id);
				return order;
			});
		});
	}

	editOrDeleteProduct(product, isDelete: boolean) {
		const productInfo = {
			delete: isDelete,
			idOrdine: this.selectedOrder.id,
			idRigaOrdine: product.id,
			prezzo: product.prezzoUnitarioOriginale,
			quantita: product.quantita,
			scontoAssolutoRichiesto: product.scontoAssolutoRichiesto,
			scontoPercentualeRichiesto: product.scontoPercentualeRichiesto,
			sconto_1_1_approvato: product.sconto_1_1_approvato,
			sconto_2_1_approvato: product.sconto_2_1_approvato,
			sconto_3_1_approvato: product.sconto_3_1_approvato,
			sconto_1_2_approvato: product.sconto_1_2_approvato,
			sconto_2_2_approvato: product.sconto_2_2_approvato,
			sconto_3_2_approvato: product.sconto_3_2_approvato,
			prezzoScontatoApprovato: product.prezzoScontatoApprovato,
		};
		this.api.modifyOrderRow(productInfo).subscribe((res) => {});
	}

	scontoPercentualeApprovatoChange(item) {
		item.prezzoScontatoApprovato = item.prodottoCommerciale.listini[0].prezzoLordo;
		item.prezzoScontatoApprovato = item.prezzoScontatoApprovato - (item.sconto_1_1_approvato * item.prezzoScontatoApprovato) / 100;
		item.prezzoScontatoApprovato = item.prezzoScontatoApprovato - (item.sconto_2_1_approvato * item.prezzoScontatoApprovato) / 100;
		item.prezzoScontatoApprovato = item.prezzoScontatoApprovato - (item.sconto_3_1_approvato * item.prezzoScontatoApprovato) / 100;
		item.prezzoScontatoApprovato = item.prezzoScontatoApprovato - (item.sconto_1_2_approvato * item.prezzoScontatoApprovato) / 100;
		item.prezzoScontatoApprovato = item.prezzoScontatoApprovato - (item.sconto_2_2_approvato * item.prezzoScontatoApprovato) / 100;
		item.prezzoScontatoApprovato = item.prezzoScontatoApprovato - (item.sconto_3_2_approvato * item.prezzoScontatoApprovato) / 100;
	}

	/* Restituisce lo sconto attuale del prodotto ( se non valorizzato dall'agente ritorna quello del listino ) */
	getSconto(tipo, prodottoCarrello) {
		const scontoAgente = prodottoCarrello['sconto_' + tipo + '_approvato'];
		const scontoListino = prodottoCarrello.prodottoCommerciale.listini[0]['sconto_' + tipo];
		return scontoAgente ?? scontoListino ?? 0;
	}
}
